import { lazy } from 'react';
const SalesForecast = lazy(() => import('./SalesForecast'));

const SalesForeCastConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/salesForecast',
            element: <SalesForecast/>,
        },

    ],
};

export default SalesForeCastConfig;
